const DIALOG_SUBMIT_BTN_SELECTOR =
  '.tox-dialog .tox-dialog__footer .tox-button:not(.tox-button--secondary):not(.tox-button--naked)';

const DISABLED_BTN_STYLES = { opacity: '0.5', cursor: 'not-allowed', pointerEvents: 'none' };
const ENABLED_BTN_STYLES = { opacity: '', cursor: '', pointerEvents: '' };

const ERROR_INPUT_STYLES = {
  borderColor: 'var(--color-danger)',
  background: 'var(--color-danger-bg)',
};
const CLEAR_INPUT_STYLES = { borderColor: '', background: '' };

const ERROR_MESSAGE_CSS = [
  'color:var(--color-danger)',
  'font-size:var(--font-size-caption)',
  'font-weight:700',
  'line-height:var(--line-height-caption)',
  'font-family:var(--font-family-base)',
  'margin-top:2px',
].join(';');

export function getDialogSubmitBtn() {
  return document.querySelector(DIALOG_SUBMIT_BTN_SELECTOR);
}

export function setDialogSubmitEnabled(enabled) {
  const btn = getDialogSubmitBtn();
  if (!btn) return;
  btn.disabled = !enabled;
  Object.assign(btn.style, enabled ? ENABLED_BTN_STYLES : DISABLED_BTN_STYLES);
}

export function showFieldError(labelText, message) {
  const dialog = document.querySelector('.tox-dialog');
  if (!dialog) return;

  for (const group of dialog.querySelectorAll('.tox-form__group')) {
    const label = group.querySelector('.tox-label');
    if (label?.textContent?.trim() !== labelText) continue;

    group.querySelector('.wt-field-error')?.remove();

    const input = group.querySelector('.tox-textfield');
    if (input) Object.assign(input.style, ERROR_INPUT_STYLES);

    const div = document.createElement('div');
    div.className = 'wt-field-error';
    div.style.cssText = ERROR_MESSAGE_CSS;
    div.textContent = message;
    group.appendChild(div);
    break;
  }
}

export function clearFieldError(labelText) {
  const dialog = document.querySelector('.tox-dialog');
  if (!dialog) return;

  for (const group of dialog.querySelectorAll('.tox-form__group')) {
    const label = group.querySelector('.tox-label');
    if (label?.textContent?.trim() !== labelText) continue;

    group.querySelector('.wt-field-error')?.remove();

    const input = group.querySelector('.tox-textfield');
    if (input) Object.assign(input.style, CLEAR_INPUT_STYLES);
    break;
  }
}

export function watchDialogInputs() {
  setTimeout(() => {
    const dialog = document.querySelector('.tox-dialog');
    if (!dialog) return;

    dialog.querySelectorAll('.tox-textfield').forEach((input) => {
      input.addEventListener('input', () => {
        const group = input.closest('.tox-form__group');
        const labelText = group?.querySelector('.tox-label')?.textContent?.trim();
        if (labelText) clearFieldError(labelText);

        const hasErrors = !!dialog.querySelector('.wt-field-error');
        if (!hasErrors) setDialogSubmitEnabled(true);
      });
    });
  }, 50);
}

export function setupDialogHasValue(editor) {
  editor.on('OpenWindow', () => {
    setTimeout(() => {
      const dialog = document.querySelector('.tox-dialog');
      if (!dialog) return;

      const syncAll = () => {
        dialog.querySelectorAll('.tox-textfield, .tox-textarea').forEach((el) => {
          el.classList.toggle('has-value', el.value.length > 0);
        });
        dialog.querySelectorAll('.tox-selectfield select').forEach((el) => {
          el.classList.toggle('has-value', el.value.length > 0);
        });
        dialog.querySelectorAll('.tox-listboxfield .tox-listbox--select').forEach((btn) => {
          const label = btn.querySelector('.tox-listbox__select-label');
          btn.classList.toggle('has-value', Boolean(label?.textContent?.trim()));
        });
      };

      syncAll();
      const interval = setInterval(syncAll, 100);
      editor.on('CloseWindow', () => clearInterval(interval));
    }, 50);
  });
}
